import { render, staticRenderFns } from "./CameraAccessCard.vue?vue&type=template&id=254f6a60&scoped=true"
import script from "./CameraAccessCard.vue?vue&type=script&lang=js"
export * from "./CameraAccessCard.vue?vue&type=script&lang=js"
import style0 from "./CameraAccessCard.vue?vue&type=style&index=0&id=254f6a60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254f6a60",
  null
  
)

export default component.exports